'use strict';
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dStatus from "./app.data.-General-Practice-Status.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppRegisteredUser$$anon$24() {
}
export { $c_Lapp_data_AppRegisteredUser$$anon$24 as $c_Lapp_data_AppRegisteredUser$$anon$24 };
$c_Lapp_data_AppRegisteredUser$$anon$24.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppRegisteredUser$$anon$24.prototype.constructor = $c_Lapp_data_AppRegisteredUser$$anon$24;
/** @constructor */
function $h_Lapp_data_AppRegisteredUser$$anon$24() {
}
export { $h_Lapp_data_AppRegisteredUser$$anon$24 as $h_Lapp_data_AppRegisteredUser$$anon$24 };
$h_Lapp_data_AppRegisteredUser$$anon$24.prototype = $c_Lapp_data_AppRegisteredUser$$anon$24.prototype;
$c_Lapp_data_AppRegisteredUser$$anon$24.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_AppRegisteredUser$$anon$24.prototype.apply__O = (function() {
  return $j_app$002edata$002e$002dGeneral$002dPractice$002dStatus.$m_Lapp_data_PharmacyStatus$().schema__Lsttp_tapir_Schema();
});
var $d_Lapp_data_AppRegisteredUser$$anon$24 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppRegisteredUser$$anon$24, "app.data.AppRegisteredUser$$anon$24", ({
  Lapp_data_AppRegisteredUser$$anon$24: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_AppRegisteredUser$$anon$24 as $d_Lapp_data_AppRegisteredUser$$anon$24 };
//# sourceMappingURL=app.data.-App-Registered-User$$anon$24.js.map
